export const durationMap = {
	Y: {
		years: 1,
		days: 1,
	},
	YN: {
		years: 1,
		days: 1,
	},
	'30D': {
		days: 30,
	},
	'30DN': {
		days: 30,
	},
	'1M': {
		months: 1,
		days: 1,
	},
	'1MN': {
		months: 1,
		days: 1,
	},
	'10D': {
		days: 10,
	},
	'10DN': {
		days: 10,
	},
	'10DP': {
		days: 10,
	},
	'10DPN': {
		days: 10,
	},
	'10DB': {
		days: 10,
	},
	'10DBN': {
		days: 10,
	},
	'1DP': {
		days: 1,
	},
	'1DPN': {
		days: 1,
	},
	'1DB': {
		days: 1,
	},
	'1DBN': {
		days: 1,
	},
	W: {
		weeks: 1,
	},
	WN: {
		weeks: 1,
	},
	'6M': {
		months: 6,
		days: 1,
	},
	'6MN': {
		months: 6,
		days: 1,
	},
};

//one day vignettes for pkw/motorrad and member/non-member
export const oneDayVignettes = ['1DP', '1DB', '1DPN', '1DBN'];
